<div class="row login-page">
    <div class="col-md-12 text-center">
      <div class="main-circle">
        <!-- <div class="close-icon" *ngIf="otpContent">
          <button mat-icon-button class="close-button" (click)="onOTPClose()">
            <mat-icon class="icon" color="">close</mat-icon>
          </button>
        </div> -->
  
        <!-- Login Form -->
        <div class="row" [ngClass]="{ 'display-none': !loginContent }">
            <div class="col-sm-12">
          <form #f="ngForm" [formGroup]="topHeaderForm" class="col-sm-12 login-form">
            <mat-form-field color="accent" appearance="standard" class="field email-address">
              <ngx-mat-intl-tel-input
                [onlyCountries]="['us', 'in', 'id']"
                [preferredCountries]="['us']"
                inputPlaceholder="Registered number"
                [enablePlaceholder]="true"
                name="phone"
                (countryChanged)="CountryChangedEvent($event)"
                formControlName="phone"
              ></ngx-mat-intl-tel-input>
              <mat-error *ngIf="f.form.controls['phone']?.errors?.required">
                Phone is required
              </mat-error>
              <mat-error *ngIf="f.form.controls['phone']?.errors?.validatePhoneNumber">
                Invalid phone number
              </mat-error>
            </mat-form-field>
  
            <mat-form-field color="accent" appearance="standard" class="field password">
              <input
                [type]="isPasswordVisible ? 'text' : 'password'"
                matInput
                formControlName="password"
                placeholder="Password"
              />
              <mat-error *ngIf="f.form.controls['password']?.errors?.required">
                Password is required
              </mat-error>
            </mat-form-field>
          </form>
  
          <!-- Toggle Password Visibility -->
          <div class="col-sm-12 show-code-otp login-group">
            <button class="visibility-btn" (click)="togglePasswordVisibility()" type="button">
              <mat-icon matSuffix class="eye-icon">
                {{ isPasswordVisible ? 'visibility' : 'visibility_off' }}
              </mat-icon>
              <span class="show-code">show code</span>
            </button>
            <button (click)="onLogin()" class="login-btn" >Login</button>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
  